import { FeatureFlag } from '../FeatureFlag';

export const enableInstrumentManagement = new FeatureFlag({
    key: 'enable-instrument-management',
    createdOn: '2025-09-11',
    defaultValue: false,
});
